import { render, staticRenderFns } from "./SupportCtas.vue?vue&type=template&id=1806b8a7&scoped=true&lang=pug&"
import script from "./SupportCtas.vue?vue&type=script&lang=js&"
export * from "./SupportCtas.vue?vue&type=script&lang=js&"
import style0 from "./SupportCtas.vue?vue&type=style&index=0&id=1806b8a7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1806b8a7",
  null
  
)

export default component.exports